<template>
  <v-card>
    <v-card-title>
      <p class="pl-6">{{ user?.first_name }} {{ user?.last_name }}</p>
      <v-spacer></v-spacer>
      <v-btn fab class="mt-n4" :color="color" @click="showForm">
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>
    </v-card-title>
    <v-spacer></v-spacer>

    <v-data-table
      ref="table"
      :headers="headers"
      :items="list"
      :loading="loading"
      item-key="number"
      sort-by="is_active"
      :sort-desc="true"
      class="elevation-1"
      :footer-props="footer"
      :loading-text="$t('common.loading')"
      :no-results-text="$t('common.no_results')"
      :server-items-length="$store.state.user_pcr.totalCount"
      :options.sync="options"
      dense
    >
      <template v-slot:item.end_period="{ item }">
        {{ toUiDate(item.end_period) }}
      </template>
      <template v-slot:item.start_period="{ item }">
        {{ toUiDate(item.start_period) }}
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex">
          <v-img
            src="/icons/crayon.png"
            max-width="25"
            class="mr-2"
            style="cursor: pointer"
            @click="editAction(item)"
          />
          <v-img
            src="/icons/delete.png"
            style="cursor: pointer"
            max-width="20"
            class="mr-2"
            @click="deleteAction(item)"
          />
        </div>
      </template>
      <template v-slot:item.is_active="{ item }">
        <span v-if="item.is_active">{{ $t("common.yes") }}</span>
        <span v-else>{{ $t("common.no") }}</span>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="500px">
      <PrcForm
        v-model="pcrModel"
        @deleted="initialize"
        @add="$emit('add')"
        @close="dialog = false"
        :edit="edit"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { ADD, DELETE, FETCH } from "@/store/action-types"
import { mapActions } from "vuex"
import TableMixin from "@/mixins/TableMixin"
import PrcForm from "@/components/card/PcrForm.vue"
import DateMixin from "@/mixins/Date"

export default {
  name: "PrcTable",
  components: { PrcForm },
  mixins: [TableMixin, DateMixin],
  props: {
    coach: {
      type: Object,
      required: false,
    },
    pef: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      pcrModel: {},
      edit: false,
      dialog: false,
      user: null,
      options: { itemsPerPage: -1 },
      afterLoadEnable: true,
      params: { coach_id: this.coach?.id, pef_id: this.pef?.id },
    }
  },
  mounted() {
    this._initialize()
  },

  watch: {
    coach() {
      this.params = { coach_id: this.coach?.id }
      this._initialize()
    },
    pef() {
      this.params = { pef_id: this.pef?.id }
      this._initialize()
    },
  },
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
    list() {
      return this.$store.state.user_pcr.data
    },

    headers() {
      let _user = "pef"
      if (this.pef) {
        _user = "coach"
      }
      return [
        {
          value: _user + ".first_name",
          text: this.$tc("user.first_name", 1),
          sortable: false,
          width: "20%",
        },
        {
          value: _user + ".last_name",
          text: this.$tc("user.last_name", 1),
          sortable: false,
        },
        {
          value: "start_period",
          text: this.$tc("user.start_date", 1),
          sortable: false,
        },
        {
          value: "end_period",
          text: this.$tc("user.end_date", 1),
          sortable: false,
        },
        {
          value: "is_active",
          text: this.$tc("common.active", 1),
        },
        {
          value: "action",
        },
      ]
    },
  },
  methods: {
    _initialize() {
      if (this.coach) {
        this.user = this.coach
      } else {
        this.user = this.pef
      }
      this.initialize()
    },
    showForm() {
      this.pcrModel = { coach: this.coach, pef: this.pef }
      this.edit = false
      this.dialog = true
    },
    editAction(item) {
      this.pcrModel = item
      this.edit = true
      this.dialog = true
    },
    deleteAction(item) {
      if (confirm(this.$t("common.delete_confirm"))) {
        this.DELETE({ pef_id: item.pef?.id, coach_id: item.coach?.id }).then(
          () => {
            this.$emit("deleted")
          }
        )
      }
    },
    ...mapActions("user_pcr", [FETCH, DELETE, ADD]),
  },
}
</script>
